"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dispatchService = exports.commonServiceSuccess = exports.commonServiceError = exports.commonService = exports.authentication = exports.applyUserGridSettings = void 0;
exports.fetchJwttokenSN = fetchJwttokenSN;
exports.getUserGridColumns = exports.getUserApps = exports.getPersonaUser = exports.findByUserAppAndFunctionsSuccess = exports.findByUserAppAndFunctionsError = exports.findByUserAppAndFunctions = void 0;
exports.getUserSession = getUserSession;
exports.getUserSessionToken = getUserSessionToken;
exports.isActionTrackingToBeAcknowledged = isActionTrackingToBeAcknowledged;
exports.isActionTrackingToBeAcknowledgedError = isActionTrackingToBeAcknowledgedError;
exports.setEntitlementStatus = exports.loadingActionTrackingItemsToBeAcknowledged = exports.loading = void 0;
exports.setJwttokenSN = setJwttokenSN;
exports.updateprofileImage = exports.updateDepartment = exports.updateBrands = exports.updateAppsError = exports.updateApps = exports.sideNavToggle = exports.sideNavShow = exports.sideNavMenuUpdate = exports.sideNavHide = exports.setUserGridColumns = exports.setTodoStatus = exports.setPersonaUser = exports.setNumberOfActionTrackingItemsToBeAcknowledged = void 0;
var _baseLayout = require("./base-layout.constants");
var _utils = require("cornerstone_ui_core/lib/utils");
const commonService = (_ref, callback) => {
  let {
    service,
    args
  } = _ref;
  return {
    type: _baseLayout.COMMON_SERVICE,
    args,
    service,
    callback
  };
};
exports.commonService = commonService;
const dispatchService = exports.dispatchService = (0, _utils.createDispatchService)(commonService);
const commonServiceSuccess = result => ({
  type: _baseLayout.COMMON_SERVICE_SUCCESS,
  ...result
});
exports.commonServiceSuccess = commonServiceSuccess;
const getUserGridColumns = key => ({
  type: _baseLayout.GET_USER_GRID_COLUMNS,
  key
});
exports.getUserGridColumns = getUserGridColumns;
const setUserGridColumns = adaSetting => ({
  type: _baseLayout.SET_USER_GRID_COLUMNS,
  adaSetting
});
exports.setUserGridColumns = setUserGridColumns;
const applyUserGridSettings = (gridKey, userGridColumnList) => ({
  type: _baseLayout.APPLY_USER_GRID_SETTING,
  gridKey,
  userGridColumnList
});
exports.applyUserGridSettings = applyUserGridSettings;
const commonServiceError = error => ({
  type: _baseLayout.COMMON_SERVICE_ERROR,
  error
});
exports.commonServiceError = commonServiceError;
const loading = loading => ({
  type: _baseLayout.LOADING,
  loading
});
exports.loading = loading;
const sideNavToggle = () => ({
  type: _baseLayout.SIDENAV_TOGGLE
});
exports.sideNavToggle = sideNavToggle;
const sideNavShow = () => ({
  type: _baseLayout.SIDENAV_SHOW
});
exports.sideNavShow = sideNavShow;
const sideNavHide = () => ({
  type: _baseLayout.SIDENAV_HIDE
});
exports.sideNavHide = sideNavHide;
const sideNavMenuUpdate = menus => ({
  type: _baseLayout.SIDENAV_MENU,
  menus
});

/**
 * Dispatched when the user is authenticated by OKTA
 * @param  {userId} userId recieved by OKTA Login
 * @return {object} An action object with a type of GET_USERAPPS
 */
exports.sideNavMenuUpdate = sideNavMenuUpdate;
const getUserApps = userId => {
  return {
    type: _baseLayout.GET_USERAPPS,
    userId
  };
};
exports.getUserApps = getUserApps;
const updateApps = result => {
  return {
    type: _baseLayout.GET_USERAPPS_SUCCESS,
    result
  };
};
exports.updateApps = updateApps;
const updateDepartment = Dept => {
  return {
    type: _baseLayout.UPDATE_DEPARTMENT,
    Dept
  };
};
exports.updateDepartment = updateDepartment;
const updateprofileImage = profileImage => {
  return {
    type: _baseLayout.UPDATE_PROFILE_IMAGE,
    profileImage
  };
};
exports.updateprofileImage = updateprofileImage;
const updateAppsError = err => {
  return {
    type: _baseLayout.GET_USERAPPS_ERROR,
    err
  };
};
exports.updateAppsError = updateAppsError;
const findByUserAppAndFunctionsSuccess = data => {
  return {
    type: _baseLayout.FINDBYUSERAPPANDFUNCTIONS_SUCCESS,
    data
  };
};
exports.findByUserAppAndFunctionsSuccess = findByUserAppAndFunctionsSuccess;
const findByUserAppAndFunctionsError = err => {
  return {
    type: _baseLayout.FINDBYUSERAPPANDFUNCTIONS_ERROR,
    err
  };
};
exports.findByUserAppAndFunctionsError = findByUserAppAndFunctionsError;
const findByUserAppAndFunctions = (appName, userId) => {
  return {
    type: _baseLayout.FINDBYUSERAPPANDFUNCTIONS,
    appName,
    userId
  };
};
exports.findByUserAppAndFunctions = findByUserAppAndFunctions;
const authentication = _ref2 => {
  let {
    authenticated,
    userinfo
  } = _ref2;
  return {
    type: _baseLayout.AUTHENTICATION,
    authenticated,
    userinfo
  };
};

/**
 * Dispatched when user is authenticated by OKTA
 * @param  {brands} brands list recieved by servcie
 * @return {object} An action object with a type of UPDATE_BRANDS
 */
exports.authentication = authentication;
const updateBrands = brands => {
  return {
    type: _baseLayout.UPDATE_BRANDS,
    brands
  };
};

/**
 * Dispatched to set the entitlement status of the user
 * @param {*} status
 */
exports.updateBrands = updateBrands;
const setEntitlementStatus = status => {
  return {
    type: _baseLayout.SET_ENTITLEMENT_STATUS,
    status
  };
};
/**
 * Dispatched to set the showTodo status
 * @param {*} status
 */
exports.setEntitlementStatus = setEntitlementStatus;
const setTodoStatus = status => {
  return {
    type: _baseLayout.SET_SHOW_TODO,
    status
  };
};
exports.setTodoStatus = setTodoStatus;
function fetchJwttokenSN(userId, appName, decoded) {
  return {
    type: _baseLayout.FETCH_JWTTOKENSN,
    userId,
    appName,
    decoded
  };
}
function setJwttokenSN(data) {
  return {
    type: _baseLayout.SET_JWTTOKENSN,
    data
  };
}
function getUserSession(cacheKey) {
  return {
    type: _baseLayout.GET_USER_SESSION,
    cacheKey
  };
}
function getUserSessionToken(cacheKeyDetails) {
  return {
    type: _baseLayout.GET_USER_SESSION_TOKEN,
    cacheKeyDetails
  };
}
const setNumberOfActionTrackingItemsToBeAcknowledged = count => ({
  type: _baseLayout.SET_ACTION_TRACKING_TO_BE_ACKNOWLEDGED,
  count
});
exports.setNumberOfActionTrackingItemsToBeAcknowledged = setNumberOfActionTrackingItemsToBeAcknowledged;
const loadingActionTrackingItemsToBeAcknowledged = load => ({
  type: _baseLayout.LOADING_ACTION_TRACKING_TO_BE_ACKNOWLEDGED,
  load
});
exports.loadingActionTrackingItemsToBeAcknowledged = loadingActionTrackingItemsToBeAcknowledged;
function isActionTrackingToBeAcknowledged(input) {
  return {
    type: _baseLayout.IS_ACTION_TRACKING_TO_BE_ACKNOWLEDGED,
    input
  };
}
function isActionTrackingToBeAcknowledgedError(input) {
  return {
    type: _baseLayout.IS_ACTION_TRACKING_TO_BE_ACKNOWLEDGED_ERROR,
    input
  };
}
const getPersonaUser = (userId, appName) => {
  return {
    type: _baseLayout.GET_PERSONA_FOR_USER,
    userId,
    appName
  };
};
exports.getPersonaUser = getPersonaUser;
const setPersonaUser = personaData => {
  return {
    type: _baseLayout.SET_PERSONA_FOR_USER,
    personaData
  };
};
exports.setPersonaUser = setPersonaUser;